<template>
  <div class="w-full">

    <div class="w-full px-6">
      <div class="lg:flex flex-wrap">
  
        <div
          class="py-10 lg:w-3/3 w-full md:pr-6"
          v-if="course"
        >

          <div class="flex justify-between items-center">
            <router-link to='/courses'>
              <div class="flex items-center">
                <div
                  class="mr-3 w-6 h-6 rounded-full text-gray-500 border border-gray-500 flex items-center justify-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-chevron-left"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <polyline points="15 6 9 12 15 18" />
                  </svg>
                </div>
                <h4 class="text-xl text-gray-900">Kursübersicht</h4>
              </div>
            </router-link>
            <router-link v-if="isInstructorsCourse" to='/instructor-courses'>
              <div class="flex items-center">
                <div
                  class="mr-3 w-6 h-6 rounded-full text-gray-500 border border-gray-500 flex items-center justify-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-chevron-left"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <polyline points="15 6 9 12 15 18" />
                  </svg>
                </div>
                <h4 class="text-xl text-gray-900">Meine Kurse</h4>
              </div>
            </router-link>

            <v-autocomplete
              chips
              closable-chips
              color="blue-grey-lighten-2"
              item-title="name"
              item-value="name"
              label="Select"
              multiple
            >
            </v-autocomplete>

 <!--                <Loading v-model: active="isLoading"
                 :can-cancel="true"
                 :on-cancel="onCancel"
                 :is-full-page="fullPage"/> 
                  v-model="fullPage"
                 -->
                 <section>
                 <b-tooltip label="Abbrechen und zurück">
            <b-button label="Abbrechen"
              v-if="isInstructorsCourse"
              v-on:click="cancle"
              class="bg-red-500 text-white font-bold rounded-full"
              @error="danger"
              v-bind:class="{
                'hover:bg-red-600': edited,
              }"
            >
              Abbrechen
            </b-button>
            </b-tooltip>
            <b-tooltip label="Kurs als Entwurf speichern">
            <b-button label="Entwurf"
              v-if="isInstructorsCourse"
             
              class="bg-yellow-500 text-white font-bold rounded-full"
              @click="checkChanges"
              @error="danger"
              v-bind:class="{
                'hover:bg-yellow-600': edited,
              }"
            >
              Entwurf
            </b-button>
            </b-tooltip>
          <b-tooltip label="Kurs speichern">
            <b-button label="Speichern"
              v-if="isInstructorsCourse"
             
              class="bg-green-500 text-white font-bold py-1 px-4 rounded-full"
              @click="saveChanges"
              @error="danger"
              v-bind:class="{
                'opacity-50': !edited,
                'cursor-not-allowed': !edited,
                'opacity-100': edited,
                'hover:bg-green-600': edited,
              }"
              :disabled="!edited"
            >
              Speichern
            </b-button>
            </b-tooltip>

          </section>
           <!-- <b-button @click="open = true">Show</b-button> -->
          </div>
          <br>

<!-- Toogle Geschützer Kurs  this.course.isPublic -->
          <section>
           <div v-if="isInstructorsCourse">
            <div class="box">
              <p><strong>Entwurf</strong></p>
                <div :class="{'active': this.course.isDraft}" class="toggle_container">
                  <span>
                  <ToggleDraftButton id="event_handle" v-on:change="triggerEventDraft" />
                  <font-awesome-icon
                  v-if="course.isDraft"
                  :icon="lockedIcon"
                  color="orange"
                  class="iconPanel"
                  />
                </span>
                </div>
            </div>
          </div>
            <!-- Toogle Geschützer Kurs  this.course.isPublic -->
<!--             <div v-if="isInstructorsCourse">
            <div class="box">
              <p><strong>Kurs für Zielgruppe</strong></p>
                <div :class="{'active': this.course.isProtected}" class="toggle_container2">
                  <span>
                  <ToggleProtectButton id="event_handle2" v-on:change="triggerEventProtect" />
                  <font-awesome-icon
                  v-if="course.isProtected"
                  :icon="lockedIcon"
                  color="red"
                  class="iconPanel"
                  />
                </span>
                </div>
            </div>
          </div> -->
<!-- Toogle Public Course  this.course.isPublic -->
          <div v-if="isInstructorsCourse">
            <div class="box">
              <p><strong>Öffentlicher Kurs</strong></p>
                <div :class="{'active': this.course.isPublic}" class="toggle_container3">
                  <span>
                  <TogglePublicButton id="event_handle3" v-on:change="triggerEvent" />
                  <font-awesome-icon
                    v-if="course.isPublic"
                    :icon="lockedIcon"
                    class="iconPanel"
                    />
                  </span>
                </div>
              </div>
          </div>
<!-- Toggle Invite Course -->
          <div v-if="isInstructorsCourse">
            <div :class="classObject">
              <div class="box">
                <p><strong>Rechtlich geschützter Kurs (Automatisch)</strong></p>
                <font-awesome-icon
                  v-if="course.noLicence"
                  :icon="lockedIcon"
                  color="blue"
                  class="iconPanel"
                  />
                  <div :class="{'active': this.course.isInvite}" class="toggle_container4">
                    <span>
                    <ToggleCCButton id="event_handle4" v-on:change="triggerEventCC" />
                    </span>
                  </div>
              </div>
            </div>
          </div>
         <!-- Toogle Geschützer Kurs  this.course.isPublic -->
           <div v-if="isInstructorsCourse">
            <div class="box">
              <span>
              <p><strong>Einladungskurs</strong></p>
              <font-awesome-icon
              v-if="course.isInviteCourse"
              :icon="lockedIcon"
              color="green"
              class="iconPanel"
              />
              </span>
                <div :class="{'active': this.course.isInviteCourse}" class="toggle_container5">
                  <span>
                  <ToggleInviteButton id="event_handle5" v-on:change="triggerEventInvite" />
                </span>
                </div>
            </div>
          </div>
          </section>

          <div>
            <section>
              <br>
              <b-message 
              title="Hinweis!" 
              type="is-warning" 
              has-icon
              size="is-medium"
              v-model="isActiveHint" 
              aria-close-label="Close message">
                Bitte als erstes eine Kategorie und eine Fähigkeit auswählen! Diese Zuordnungen können nur über den Systemadministrator neu konfiguriert werden!    
              </b-message>
              <br>
<!-- UUID -->
<!-- <div class="field has-addons">
        <button id="generateButton" v-on:click.prevent="createNewUUID()" class="control button is-medium is-primary is-rounded">
          <span class="underlined">G</span>enerate
      </button>
          <a id="copyToClipboard" v-on:click.prevent="copyToClipboard" class="button control is-medium">
              <span class="icon">
                <i class="fa fa-clipboard"></i>
              </span>
            </a>
                  <div class="control" style="width:100%">
                    <input v-on:focus="$event.target.select()" ref="generator" v-model="shownUUID" id="generator" class="input is-medium is-rounded" type="text" readonly placeholder="GUID goes here">
                  </div>
  </div> -->
            </section>
            <!-- <b-button @click="scrollToBottom">Ganz nach unten</b-button> -->
          </div>
          <div
            v-if="this.course.isProtected"
            class="text-gray-800 text-5xl sm:text-center text-center mt-2 mb-2"
            v-bind:class="{
            protectedCourse: active
            }"
          > 
<!--           <b-field grouped>
            <b-switch 
            size="is-medium"
              id="feuerwehr" 
              value="Feuerwehr" 
              v-model="isFire" 
              @click="warn('Warnung Feuerwehr', event)"
            >Feuerwehr</b-switch>
            <b-switch 
            size="is-medium"
              id="polizei" 
              value="Polizei" 
              v-model="isPolice"
              v-on:click="polizeiChecked($event)"
            >Polizei</b-switch>
        </b-field> -->
            <!-- <div>Checked Institutes: {{ checkedNames }}</div> -->
              <input 
              type="checkbox" 
              id="feuerwehr" 
              value="Feuerwehr" 
              v-model="checkedNames" 
              v-on:click="fuerwehrChecked($event)"
              >
              <label for="feuerwehr">Feuerwehr</label>

              <input 
              type="checkbox" 
              id="polizei" 
              value="Polizei" 
              v-model="checkedNames"
              v-on:click="polizeiChecked($event)"
              >
              <label for="polizei">Polizei</label>
          </div>
          <div v-else> 
          </div>
                <div 
                  v-if="this.course.isInvite"
                  class="text-gray-800 text-5xl mt-2 mb-2 sm:text-center text-center"
                  v-bind:class="{
                  inviteCourse: active
                  }"
                  >
                  <section>
                    <b-message 
                    title="Hinweis!" 
                    type="is-info" 
                    has-icon
                    size="is-medium"
                    v-model="isActiveHintVr" 
                    aria-close-label="Close message">
                    Dieser Kurs ist ein Invite Kurs und kann nur mit Einladungen genutzt werden.  
                    </b-message>
                  </section> 
                  <!-- <h3>Dieser Kurs ist ein Invite Kurs</h3> -->
                  </div>
                  <div v-else> 
                </div>
                <div class="card py-10 w-full px-6">
          <div v-bind:class="{
                publicCourse: active
              }">
          <editable-text-field
            v-if="isInstructorsCourse"
            :showEdit="true"
            :text="course.name"
            :content.sync="course.name"
            @save="activateSave"
            class="font-bold text-gray-800 text-5xl mt-6 mb-8 sm:text-left text-center"
          />
          <h3
            v-if="!isInstructorsCourse"
            class="font-bold text-gray-800 text-5xl mt-6 mb-8 sm:text-left text-center"
          >
            {{ course.name }}
          </h3>
          <div class="sm:flex items-center">
            
            <button
              v-if="!isInstructorsCourse"
              class="focus:outline-none ml-0 md:mr-5 bg-red-700 transition duration-150 ease-in-out hover:bg-red-800 rounded text-white sm:px-3 px-6 py-2 text-xl sm:ml-0 ml-8"
            >
              {{ course.course_category.name }}
            </button>
            <div class="flex items-center mx-auto mt-6 flex flex-wrap">
              <div>
                <h1 class="font-bold text-gray-900 text-3xl mb-6">Kurskategorie</h1>
                  <select
                    name="categories"
                    id="categories"
                    v-if="isInstructorsCourse"
                    @change="changeCategory()"
                    class="focus:outline-none ml-0 md:mr-5 bg-red-700 transition duration-150 ease-in-out hover:bg-red-800 rounded text-white sm:px-3 px-8 py-2 text-xl sm:ml-0 mr-8"
                    >
                  <option
                    v-for="category in courseCategories"
                    :key="course.name + category.id"
                    :selected="category.name === 'Bitte auswählen:'"
                    :value="category.name"
                  >
                  {{ category.name }}
                  </option>
                  </select>
              </div>
                  <button 
                    class="focus:outline-none ml-0 md:mr-5 bg-red-700 transition duration-150 ease-in-out hover:bg-red-800 rounded text-white sm:px-3 px-6 py-2 text-xl sm:ml-0 ml-8" 
                    v-if="!isInstructorsCourse">
                    {{ course.skill.name }}
                  </button>
              
              <div>
                <h1 class="font-bold text-gray-900 text-3xl mb-6">Erfahrung</h1>                
                    <select
                      name="skills"
                      id="skills"
                      v-if="isInstructorsCourse"
                      @change="changeSkill()"
                      class="focus:outline-none ml-0 md:mr-5 bg-red-700 transition duration-150 ease-in-out hover:bg-red-800 rounded text-white sm:px-3 px-8 py-2 text-xl sm:ml-0 mr-8"
                    >
                    <option
                      v-for="skill in skills"
                      :key="skill.name"
                      :selected="skill.name === 'Bitte auswählen:'"
                      :value="skill.name"
                    >
                    {{ skill.name }}
                    </option>
                    </select>
              </div>
             
            <div>
            <ul>
              <li
                class="text-gray-600 flex items-center text-base px-6 sm:border-l border-gray-300"
              >
              <p>Kursdauer :</p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="flex-shrink-0 icon icon-tabler icon-tabler-clock"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" />
                  <circle cx="12" cy="12" r="9" />
                  <polyline points="12 7 12 12 15 15" />
                </svg>
            <editable-text-field
            v-if="isInstructorsCourse"
            :text="course.duration"
            :content.sync="course.duration"
            @save="activateSave"
            class="text-gray-600 mb-2"
              />
                <p class="ml-3">min</p>
              </li>
              
<!--               <li
                class="text-gray-600 flex items-center text-base px-6 sm:border-r sm:border-l border-gray-300 sm:py-0 py-2"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="flex-shrink-0 icon icon-tabler icon-tabler-file-horizontal"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" />
                  <path d="M16 5v4a1 1 0 0 0 1 1h4" />
                  <path
                    d="M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-7l-5 -5h-11a2 2 0 0 0 -2 2z"
                  />
                </svg>
                <p class="ml-3">
                  {{ course.sections ? course.sections.length : 0 }} Contentmodule
                </p>
              </li> -->
 <!--              <li class="text-gray-600 flex items-center text-base px-6">
                <p>&#8727; Erfahrung</p>
                
                <p v-if="!isInstructorsCourse">
                  {{ course.skill.name }}
                </p>
                <select
                  name="skills"
                  id="skills"
                  v-if="isInstructorsCourse"
                  @change="changeSkill()"
                  class="ml-5"
                >
                  <option
                    v-for="skill in skills"
                    :key="skill.name"
                    :selected="skill.id = 3"
                    :value="skill.name"
                  >
                    {{ skill.name }}
                  </option>
                </select>
                
              </li> -->
            </ul>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-8 mb-6 border-t border-gray-300" />
      <h4 class="text-gray-900 text-xl font-medium mb-6">Kursübersicht</h4>
      <editable-text-field
      id="nameField"
      v-if="isInstructorsCourse"
      :text="course.description"
      :content.sync="course.description"
      @save="activateSave"
      class="text-gray-600 mb-2"
      />
      <p v-if="!isInstructorsCourse" class="text-gray-600 mb-2">
        {{ course.description }}
      </p>
    </div>
    <br>
    <div>
            <b-button
              v-if="isOpen === true"
              label="Kurs Control Panel Ausschalten"
              size="is-medium"
              type="is-primary is-light"
              class="py-3"
              @click="isOpen = !isOpen" 
              aria-controls="contentIdForA11y2"
              />
              <b-button
              v-else
              label="Kurs Control Panel Einschalten"
              size="is-medium"
              type="is-primary "
              class="py-3 "
              @click="isOpen = !isOpen" 
              aria-controls="contentIdForA11y2"
              />
            <b-collapse 
              aria-id="contentIdForA11y2"
              class="panel"
              v-model="isOpen"
              animation="slide">
                <div class="panel-block">
                  <!-- <span>
                <button
                  v-if="isInstructorsCourse"
                  class="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full"
                  v-on:click="createSection"
                >
                  + Kapitel
                </button>
              </span> -->
              <span>
                <b-field>

  <!-- STARTING CONTENT MONDULE LISTING -->

              <div>
                <b-dropdown
             :scrollable="isScrollable"
             :max-height="maxHeight"
             v-model="selectedOptions"
             aria-role="list"
             trap-focus
             class="dropdown is-up"
             >
            <template #trigger>
              <div
                v-for="(section, section_index) in course.sections"
                class="py-10  w-full md:pl-6 md:px-0 px-4"
                v-show="section_index < 1"
                :key="section.id"
                :id="section_index"
              >
                <b-button
                class="bg-green-500 hover:bg-green-600 text-white ml-5 font-bold px-4 rounded-full"
                type="is-primary"
                icon-right="menu-down">
                <div v-if="selectedOptions.length == 0"><font-awesome-icon :icon="['fas', 'puzzle-piece']" /><span>&nbsp;Contentmodule auswählen {{ selectedOptions.length }}</span></div>
                <div v-else>
                  <font-awesome-icon :icon="['fas', 'puzzle-piece']"/>
                  <span>&nbsp;{{ selectedOptions.name }}</span>
                </div>

              </b-button>
              
              <span v-if="selectedOptions.licence === false"><font-awesome-icon
                      :icon="lockedIcon"
                      color="blue"
                      class="px-2 mt-3"
                    /></span>
                  </div>
                 
            </template>
                 <b-dropdown-item custom aria-role="listitem">
                   <b-input 
                  v-model="searchTerm"
                  type="search"
                  placeholder="Suche nach Contentmodulen..." 
                  expanded 
                  icon="search"
                  icon-pack="fas"
                  />
                </b-dropdown-item>

                <!-- <b-dropdown-item v-for="menu of filteredData" :key="menu" custom aria-role="listitem">
                    <div class="media-content">
                            <h3>Content auswählen:</h3>
                        </div>
                        {{menu.name}}
                </b-dropdown-item> -->
                <b-dropdown-item
                    v-for="(menu, index) in filteredData"
                    :key="index"
                    :value="menu" aria-role="listitem"
                    >
                    <div class="box">
                      <div v-if="menu.licence === false" class="media-content"><font-awesome-icon
                        :icon="lockedIcon"
                        color="blue"
                        class="items-center"
                        /></div>
                        <div class="media">
                          <b-icon class="media-left" :icon="menu.icon"></b-icon>
                          
                          
                          <div class="media-content">
                            
                            <h3><strong>{{menu.name}}</strong></h3>
                              <p>{{ menu.description }}</p> 
                              <b-field>
                                <b-tag>{{ menu.module_category.name }}</b-tag>
                              </b-field>
                            <div v-for="media in menu.media" :key="media.id" class="mt-2">
                            
                              <b-tooltip 
                                type="is-light"
                                :triggers="['click']"
                                :auto-close="['outside', 'escape']">
                                <template v-slot:content>
                                    <b-icon icon="heart" type="is-danger"></b-icon>
                                    <b-icon icon="thumb-up" type="is-info"></b-icon>
                                    <b-icon icon="thumb-down" type="is-warning"></b-icon>
                                    <b-icon icon="emoticon-cool"></b-icon>
                                </template>
                                <b-button disabled>
                              
                                  <div
                                    v-if="media.mime == 'application/pdf'"
                                    class="flex items-center"
                                  >
                                    <!-- <img src="/assets/images/PDF_file_icon.png" /> -->
                                    <font-awesome-icon class="red-color" icon="fa-file-pdf" />
                                    <a target="_blank">&nbsp;{{
                                      media.name 
                                    }}</a>
                                  </div>
                              <div class="" v-if="media.mime == 'video/mp4'">
                            
                                <a target="_blank">{{
                                  media.name
                                }}</a>
                              <!-- <b-tooltip position="is-bottom" multilined>
                                <b-button label="Preview" type="is-info is-light" />
                                <template v-slot:content>
                                  <video controls class="video-width">
                                    <source 
                                      :src="media.url" 
                                      :type="media.mime"/>
                                    Sorry, your browser doesn't support embedded videos.
                                    </video>
                                </template>
                              </b-tooltip> -->
                              </div>
                            </b-button>
                          </b-tooltip>
                          <b-tooltip 
                          position="is-bottom" 
                          multilined 
                          :delay="1000"
                          :auto-close="['outside', 'escape']"
                          >
                                <b-button v-show="media.mime == 'video/mp4'" label="Preview" type="is-info is-light" />
                                <template v-slot:content>
                                  <div class="" v-if="media.mime == 'video/mp4'">
                                  <video 
                                  controls 
                                  class="video-width"
                                  >
                                    <source 
                                      :src="media.url" 
                                      :type="media.mime
                                      "/>
                                    Sorry, your browser doesn't support embedded videos.
                                    </video>
                                  </div>
                                 
                                </template>
                              </b-tooltip>
                            </div>
                        </div>
                        <!-- <b-button
                          label="Toggle"
                          type="is-primary"
                          @click="active = !active" /> -->
                       <!--  <div>
                          <b-button
                            label="Preview"
                            type="is-primary"
                            size="is-small"
                            @click="cardModal" />
                        </div>  -->
                        <!-- <b-button
                              label="Anzeigen"
                              type="is-primary"
                              @click="active = !active" /> -->
                      </div>
                    </div>
                </b-dropdown-item>
                <b-button
                  label="Auswahl aufheben"
                  type="is-warning is-light"
                  expanded
                  @click="selectedOptions = []" />
            </b-dropdown>
 <!--                <b-select
                      name="modules"
                      id="modules"
                      v-if="isInstructorsCourse"
                      class="ml-5 "
                      placeholder="Bitte ein Modul auswählen" expanded
                    >
                   -- :selected="mod.id = 57" --
                      <option
                        v-for="mod in modulesNotInSection(section_index)"
                        :key="section_index + mod.id"
                        :value="mod.name"
                      >
                      <div v-if="mod.licence === false" class="media-content">
                        Keine CC-Lizenz |</div> {{ mod.name }}
                      </option>
                    </b-select> -->
                </div>  

<!-- END CONTENT MONDULE LISTING -->

                </b-field> 
              </span>
              <span>
              <div class="py-10  w-full md:pl-6 md:px-0 px-4" v-if="user.role.name > 0">
              <button 
              @click="open = true"
              class="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full"
              >
              Bibliothek anzeigen
              </button>
                <template>
                  <b-sidebar
                    type="is-light"
                    :fullheight="fullheight"
                    :fullwidth="fullwidth"
                    :overlay="overlay"
                    :right="right"
                    v-model="open"
                  >
                  <ModulesSection />
                </b-sidebar>
                </template>
              </div>
            </span>
              </div>
            </b-collapse>


<!-- SECTION BEGINS -->

            <div
              v-for="(section, section_index) in course.sections"
              :key="section.id"
              :id="section.name + section_index"
              class="card py-10 w-full px-6"
            >
              <hr class="my-8 border-t border-gray-300" />
              <div class="flex items-center">
                <editable-text-field
                  v-if="isInstructorsCourse"
                  :showEdit="true"
                  :text="course.sections[section_index].name"
                  :content.sync="course.sections[section_index].name"
                  @save="activateSave"
                  class="text-gray-900 text-xl font-medium"
                />
                <h4
                  v-if="!isInstructorsCourse"
                  class="text-gray-900 text-xl font-medium"
                >
                  {{ section.name }}
                </h4>
<!--                 <select
                  name="modules"
                  id="modules"
                  v-show="section_index < 1"
                  v-if="isInstructorsCourse"
                  class="ml-5"
                >
                  <option
                    v-for="mod in modulesNotInSection(section_index)"
                    :key="section_index + mod.id"
                    :selected="mod.id"
                    :value="mod.name"
                  >
                    {{ mod.name }}
                  </option>
                </select> -->
                <button
                  v-if="isInstructorsCourse && isOpen"
                  class="bg-green-500 hover:bg-green-600 text-white ml-5 font-bold px-4 rounded-full"
                  v-on:click="addModule(section_index)"
                >
                  + Contentmodul {{ selectedOptions.length > 0 ? 'hinzufügen' : '' }}
                </button>
                <button
                  v-if="isInstructorsCourse"
                  class="bg-red-500 hover:bg-red-600 text-white ml-5 font-bold px-4 rounded-full"
                  v-on:click="deleteSection(section_index)"
                >
                  Kapitel Löschen
                </button>
              </div>

<!--    Übersicht der Materiallien und Module des Kapitels           
            <div class="flex items-center mt-2">
                <p class="text-gray-600 text-sm">3 Lectures</p>
                <span class="mx-2 rounded-full w-1 h-1 bg-gray-300"></span>
                <p class="text-gray-600 text-sm">2 Videos</p>
                <span class="mx-2 rounded-full w-1 h-1 bg-gray-300"></span>
                <p class="text-gray-600 text-sm">2 Assignments</p>
              </div> -->

              <editable-text-field
                v-if="isInstructorsCourse"
                :text="course.sections[section_index].description"
                :content.sync="course.sections[section_index].description"
                @save="activateSave"
                class="text-gray-600 mt-6 text-sm"
              />
              <p v-if="!isInstructorsCourse" class="text-gray-600 mt-3 text-sm">
                {{ section.description }}
              </p>

              <div
                v-for="(mod, mod_index) in section.modules"
                :key="'mod_div' + mod.id + mod_index"
              >
                <div class="flex mt-6 justify-between items-center">
                  <div class="flex items-center">
                    <h5 class="text-gray-900 font-medium">
                      {{ section_index + 1 }}.{{ mod_index + 1 }}
                    </h5>
                    <!-- <editable-text-field
                      v-if="isInstructorsCourse"
                      :text="
                        course.sections[section_index].modules[mod_index].name
                      "
                      :content.sync="
                        course.sections[section_index].modules[mod_index].name
                      "
                      @save="activateSave"
                      class="text-gray-900 font-medium ml-3"
                    /> -->
                    <h5 class="text-gray-900 font-medium ml-3">
                      {{ mod.name }}
                    </h5>
                    <div v-if="mod.licence">
                    <section>
                        <b-field>
                          <b-tooltip position="is-bottom" multilined>
                            <b-tag type="is-info is-light" rounded size="is-medium">CC-Lizenz</b-tag>
                            <template v-slot:content>
                                <b>CC-Lizenzen:</b>
                                <div v-if="mod.CC.CC_BY === 'BY'">BY</div>
                                <div v-if="mod.CC.CC_NC === 'NC'">NC</div>
                                <div v-if="mod.CC.CC_ND === 'ND'">ND</div>
                                <div v-if="mod.CC.CC_SA === 'SA'">SA</div>
                            </template>
                        </b-tooltip>
                            
                        </b-field>
                    </section>
                  </div>
                  <div v-else>
                    <section>
                        <b-field>
                          <b-tooltip position="is-bottom" multilined>
                            <b-tag type="is-danger is-light" rounded size="is-medium">
                              <font-awesome-icon
                                :icon="lockedIcon"
                                color="blue"
                                class="items-center"
                              />
                              CC-Lizenz</b-tag>
                            <template v-slot:content>
                                <b>CC-Lizenzen</b>, Leider haben wir keine Freigabe.
                            </template>
                        </b-tooltip>
                            
                        </b-field>
                    </section>
                  </div>
                
                    <!-- <input
                      type="file"
                      :id="section_index + '.' + mod_index"
                      v-on:click="addFile(section_index, mod_index)"
                      class="ml-6"
                      multiple
                    /> -->
                  </div>
                  <div>
                    <b-button
                    v-if="isInstructorsCourse || superAdmin"
                    rounded
                    size="is-small"
                    type="is-danger"
                    class="bg-red-500 hover:bg-red-600 text-white ml-5 font-bold px-4 rounded-full"
                    v-on:click="deleteModule(course.sections[section_index].id, mod.id)"
                    >
                    <font-awesome-icon :icon="['fas', 'trash']" />
                      Contentmodul entfernen
                    </b-button>   
                  </div>
 <!--                  <div data-menu class="cursor-pointer">
                    <div class="flex items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-label="Hide"
                        class="icon icon-tabler icon-tabler-chevron-up"
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="#718096"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" />
                        <polyline points="6 15 12 9 18 15" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-label="Show"
                        class="hidden icon icon-tabler icon-tabler-chevron-down"
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="#718096"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" />
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                      <span class="ml-6 text-gray-600 text-sm">12:29</span>
                    </div>
                  </div> -->
                 
                </div>
                <!-- <editable-text-field
                  v-if="isInstructorsCourse"
                  :text="
                    course.sections[section_index].modules[mod_index]
                      .description
                  "
                  :content.sync="
                    course.sections[section_index].modules[mod_index]
                      .description
                  "
                  @save="activateSave"
                  class="text-gray-600 text-sm mt-4"
                />
                <p
                  v-if="!isInstructorsCourse"
                  class="text-gray-600 text-sm mt-4"
                >
                  {{ mod.description }}
                </p> -->
                <div v-for="media in mod.media" :key="media.id" class="mt-2">
                  <div
                    v-if="media.mime == 'application/pdf'"
                    class="flex items-center"
                  >
                  <font-awesome-icon class="red-color" icon="fa-file-pdf" />
                    <a :href="media.url" target="_blank">&nbsp;{{
                      media.name
                    }}</a>
                    <!-- <img src="/assets/images/PDF_file_icon.png" /> -->
                  </div>
                <div class="video" v-if="media.mime == 'video/mp4'">
                    <video controls class="video-width">
                    <source 
                      :src="media.url" 
                      :type="media.mime"/>
                    Sorry, your browser doesn't support embedded videos.
                    </video>
                    <a :href="media.url" target="_blank">Alternativer Link: {{
                      media.name
                    }}</a>
                  </div>
                  <div v-if="media.mime == 'application/zip'">
                    <!-- <font-awesome-icon class="text-xl" :icon="['fa-solid', 'fa-file-zipper']" /> -->
                    <!-- <video :src="'//' + API_URL + media.url"></video> -->
                    <a :href="media.url" target="_blank">&nbsp;{{
                      media.name
                    }}</a>
                  </div>
                  <div v-if="media.mime == 'application/zip'">
                    media.name
                    <!-- <video :src="'//' + API_URL + media.url"></video> -->
                  </div>
                  <div v-if="media.mime == 'text/html'">
                    <a :href="media.url" target="_blank"
                      >Die Seite öffnen</a
                    >
                  </div>
                  <div v-if="!media.url">{{ media }}</div>

                </div>
                <div>
                  <div v-for="(mod, mod_index) in section.modules" :key="'mod_div' + mod.id + mod_index">
                    <div v-if="mod.iFrame_URL">
                      <h1>Webinar Link</h1>
                      <div class="iframe-container">
                        <iframe :src="mod.iFrame_URL" frameborder="0" allowfullscreen></iframe>
                      </div>
                      <!-- <a :href="mod.iFrame_URL" target="_blank">{{ mod.iFrame_URL }}</a> -->
                      <b-button
                        type="is-link is-light"
                        tag="a"
                        target="_blank"
                        :href="mod.iFrame_URL"
                        icon-left="github-circle"
                        >
                        In einem neuen Fenster öffnen
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="isInstructorsCourse" class="card py-10 w-full my-8 px-6">
      <div class="container px-2 py-2">
            <b-button
              type="is-success"
              size="is-medium"
              rounded
              class="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full"
              v-on:click="createSection"
            >
            <font-awesome-icon :icon="['fas', 'circle-plus']" />
              Kapitel
            </b-button>
          </div>
      </div>
<!-- SECTION ENDS -->

          </div>

<!--        // Statistik Component   
          <div class="py-10 lg:w-1/3 w-full md:pl-6">
            <h4 class="text-gray-900 text-xl font-medium mb-6">Statistics</h4>
            <div class="mb-6 flex items-center">
              <div>
                <h5 class="mb-3 text-green-500 font-light text-3xl">92%</h5>
                <p class="text-gray-900">Success Rate</p>
              </div>
              <div class="ml-16">
                <h5 class="mb-3 text-green-500 font-light text-3xl">16</h5>
                <p class="text-gray-900">Courses Taught</p>
              </div>
            </div>
          </div> -->

 <!--       // Assignment - QuizAcademy Component Placeholder   
          <hr class="my-8 border-t border-gray-300" />
          <div class="flex items-center justify-between mb-6">
            <h4 class="text-gray-900 text-xl font-medium">
              Upcoming Assignments
            </h4>
            <a class="color-blue text-sm font-bold cursor-pointer">View All</a>
          </div>
          <p class="text-gray-600 mb-6">09/02/20 - Applied UX Hueristics</p>
          <p class="text-gray-600 mb-6">09/02/20 - Applied UX Hueristics</p>
          <p class="text-gray-600">09/02/20 - Applied UX Hueristics</p>
          <div class="py-16">
            <div class="flex items-center justify-between mb-6">
              <h4 class="text-gray-900 text-xl font-medium">Resources</h4>
              <a class="color-blue text-sm font-bold cursor-pointer"
                >View All</a
              >
            </div> -->
 
<!--         // Ressourcen Placeholder für Lehrmateriallien     
            <div
              class="xl:w-full xl:mx-0 border-b border-gray-300 rounded h-12 mb-8"
            >
              <ul class="flex items-center xl:justify-between">
                <li
                  :class="{ 'bg-gray-100 text-blue-500': tab === 'Videos' }"
                  v-on:click="activeTab('Videos')"
                  class="text-sm text-gray-600 py-2 px-4 rounded text-sm cursor-pointer"
                >
                  Videos
                </li>
                <li
                  :class="{ 'bg-gray-100 text-blue-500': tab === 'Slides' }"
                  v-on:click="activeTab('Slides')"
                  class="text-sm text-gray-600 py-2 px-4 rounded text-sm cursor-pointer"
                >
                  Slides
                </li>
                <li
                  :class="{ 'bg-gray-100 text-blue-500': tab === 'Audio' }"
                  v-on:click="activeTab('Audio')"
                  class="text-sm text-gray-600 py-2 px-4 rounded text-sm cursor-pointer"
                >
                  Audio Notes
                </li>
              </ul>
            </div>
            <div class="flex items-center mb-8 text-gray-600">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-movie"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" />
                <rect x="4" y="4" width="16" height="16" rx="2" />
                <line x1="8" y1="4" x2="8" y2="20" />
                <line x1="16" y1="4" x2="16" y2="20" />
                <line x1="4" y1="8" x2="8" y2="8" />
                <line x1="4" y1="16" x2="8" y2="16" />
                <line x1="4" y1="12" x2="20" y2="12" />
                <line x1="16" y1="8" x2="20" y2="8" />
                <line x1="16" y1="16" x2="20" y2="16" />
              </svg>
              <p class="ml-4">Norman & Nielson TED talk on UX.mkv</p>
            </div>
            <div class="flex items-center mb-8 text-gray-600">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-movie"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" />
                <rect x="4" y="4" width="16" height="16" rx="2" />
                <line x1="8" y1="4" x2="8" y2="20" />
                <line x1="16" y1="4" x2="16" y2="20" />
                <line x1="4" y1="8" x2="8" y2="8" />
                <line x1="4" y1="16" x2="8" y2="16" />
                <line x1="4" y1="12" x2="20" y2="12" />
                <line x1="16" y1="8" x2="20" y2="8" />
                <line x1="16" y1="16" x2="20" y2="16" />
              </svg>
              <p class="ml-4">Norman & Nielson TED talk on UX.mkv</p>
            </div>
            <div class="flex items-center mb-8 text-gray-600">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-movie"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" />
                <rect x="4" y="4" width="16" height="16" rx="2" />
                <line x1="8" y1="4" x2="8" y2="20" />
                <line x1="16" y1="4" x2="16" y2="20" />
                <line x1="4" y1="8" x2="8" y2="8" />
                <line x1="4" y1="16" x2="8" y2="16" />
                <line x1="4" y1="12" x2="20" y2="12" />
                <line x1="16" y1="8" x2="20" y2="8" />
                <line x1="16" y1="16" x2="20" y2="16" />
              </svg>
              <p class="ml-4">Norman & Nielson TED talk on UX.mkv</p>
            </div>
 -->

       <!--  // Exams - Placeholder for QuizAcademy  -->
 <!--         <div class="flex items-center justify-between mb-6">
            <h4 class="text-gray-900 text-xl font-medium">Exams</h4>
            <a class="color-blue text-sm font-bold cursor-pointer">View All</a>
          </div>
          <p class="text-gray-600 mb-6">
            Exams have not yet been announced by your instructor, they will
            appear here once they are announced
          </p> -->
          

            <div class="py-16">
            <h4 class="text-gray-900 text-xl font-medium mb-6">Autor</h4>
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <div class="h-8 w-8">
                  <img
                    src="http://www.gravatar.com/avatar/3b3be63a4c2a439b013787725dfce802?d=identicon"
                    alt
                    class="h-full w-full rounded-full overflow-hidden shadow"
                  />
                </div>
        <div class="ml-2" v-if="user.role.name > 0">
         <h5 class="text-xs text-gray-800">{{user.firstName}}</h5>
           <p class="text-xs text-gray-800">{{ user.email }}</p>
        </div>
               
                 
             
              </div>
<!--               <button
                class="focus:outline-none ml-0 md:ml-5 bg-white transition duration-150 ease-in-out hover:bg-gray-100 rounded text-gray-800 px-3 md:px-6 py-2 text-sm border border-gray-800"
              >
                Follow
              </button> -->
            </div>
          </div> 
          
        </div>


      </div>
    </div>
    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <strong>education Brandenburg</strong> by <a href="https://jgthms.com">OSZ Palmnicken</a>. The source code is licensed
          <a href="http://opensource.org/licenses/mit-license.php">MIT</a>. The website content
          is licensed <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>.
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import Vue from 'vue';
import Buefy from 'buefy';
import { ToastProgrammatic as Toast} from 'buefy';

import gql from "graphql-tag";
// import { mapState } from "vuex";

import ModulesSection from './Modules.vue';
import ToggleInviteButton from '../components/ToggleInviteButton.vue'
import TogglePublicButton from '../components/TogglePublicButton.vue'
import ToggleCCButton from '../components/ToggleCCButton.vue'
import ToggleDraftButton from '../components/ToggleDraftButton.vue'
// import ToggleProtectButton from '../components/ToggleProtectButton.vue'

// import Loading from 'vue-loading-overlay';
// import 'vue-loading-overlay/dist/vue-loading.css';

import EditableTextField from "../components/EditableTextField.vue";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFilePdf, faLock, faUserShield, faEye, faEyeSlash  } from '@fortawesome/free-solid-svg-icons';

import { mapState } from "vuex";

import 'buefy/dist/buefy.css'

library.add(faFilePdf, faLock, faUserShield, faEye, faEyeSlash);

Vue.use(Buefy);

export default {
  name: "HelloWorld",
    components: {
    EditableTextField,
    ModulesSection,
    ToggleInviteButton,
    TogglePublicButton,
    ToggleCCButton,
    ToggleDraftButton
    // ToggleProtectButton
  },

  data: function () {
    return {
      user: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user"))
        : { role: { name: 0 } },
      course: {
        name: "Kurstitel eingeben",
        description: "Kursbeschreibung eingeben",
        course_category: {},
        isPublic: false,
        isInvite: false,
        isDraft: false,
        isInviteCourse: false,
        isProtected: false,
        isLoading: false,
        feuerwehr: false,
        polizei: false,
        noLicence: false,
        isFire: false,
        isPolice: false,
        isUpper: false,
        withHyphen: true,
        GUID: this.generateUUID,
        // fullPage: true,
        sections: [
/*           {
            name: "Titel für Kapitel eingeben",
            description: "Beschreibung eingeben",
            modules: [],
            index: 0
          }, */
        ],
        instructor: {},
      },
      active: false,
      isActiveHint: true,
      isActiveHintVr: true,
      modules: [],
      courseCategories: [],
      skills: [],
      checkedNames: [],
      JsonObjectA: [
              this.JsonObjectA
            ],
      isInstructorsCourse: true,
      edited: false,
      open: false,
      isOpen: true,
      overlay: true,
      fullheight: true,
      fullwidth: true,
      right: true,
      lockedIconShield: "fa-solid fa-user-shield",
      lockedIcon: "fas fa-lock",
      tab: "Videos",
      API_URL:
        process.env.NODE_ENV == "production"
          ? process.env.VUE_APP_STRAPI_API_URL
          : "localhost:1338",
      isScrollable: true,
      maxHeight: 600,
      searchTerm: '',
      selectedOptions: [],
    };
  },
   updated(){
    try{
        this.countlicence()
      }catch(e){
        console.log(e)
      }
  },
  
  mounted(){
    this.GUID = this.generateUUID();
    console.log("GUID", this.GUID)
    // const vm = this;
    // window.addEventListener('keyup', function(event) {  
    //   switch(event.keyCode) {
    //     case 67: // c
    //        vm.copyToClipboard();
    //       break;
    //     case 71: // g
    //       vm.GUID = vm.generateUUID();
    //       break;
    //     case 72: // h
    //       vm.withHyphen = !vm.withHyphen;
    //       break;
    //     case 85: // u
    //       vm.isUpper = !vm.isUpper;
    //       break;
    //   }
    // });
  },
  methods: {

    deleteModule(sectionIndex, modIndex){
      this.edited = true;
      try{
        var sectionId = 0
        var modId = 0
        let moduleDelete = []

        console.log("delete module...", modIndex);
        console.log("delete module in section", sectionIndex);
        console.log("course.sections", this.course.sections)
        
        for (let i = 0; i < this.course.sections.length; i++){
          const modSec = this.course.sections[i];
          const modSecArray = modSec.modules
          
          if(modSec.id === sectionIndex){
            sectionId = i
            //console.log("modSec", modSec)
          }

          for (let j = 0; j < modSecArray.length; j++){
            const secModules = modSecArray[j]
            //console.log("secModules", secModules)
            if(secModules.id == modIndex){
              //console.log("modIndex", modIndex)
              //console.log("secModules.id", secModules.id)
              modId = j
              //console.log("mod in section", secModules)
              //console.log("j",  j)
              //console.log("j",  modSec.modules[j])
              // console.log("section ID from loop", sectionId)
              // console.log("mod array ID from loop", modId)
              console.log("mod to delete", this.course.sections[sectionId].modules[modId])
              Toast.open({
              message: `Content <b>` + this.course.sections[sectionId].modules[modId].name + `</b> wurde entfernt!`,
              position: 'is-top',
              type: 'is-warning is-light'
              })
              this.course.sections[sectionId].modules.splice(modId,1)
              this.triggerEventCC(false)
            }
          }
        }
        
        return moduleDelete

        //this.triggerEventCC(false)
        
       //this.course.sections.splice(sec, 1)
    
        //this.course.sections[sectionIndex].modules.push(mod);
      }catch(e){
        console.log(e)
      }
    },
    copyToClipboard() {
        this.$refs.generator.focus();
        document.execCommand('copy');
        this.$buefy.toast.open('Copied!');
    },
    createNewUUID() {
      this.GUID = this.generateUUID();
    },
    generateUUID() { // Public Domain/MIT
        var d = new Date().getTime();
        if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
            d += performance.now(); //use high-precision timer if available
        }
        var newGuid = 'xxxx4xyx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        
        return newGuid;
    },
     scrollToBottom() {
      const container = this.$el.querySelector("#container");
      container.scrollTop = container.scrollHeight;
    },
/*     fuerwehrChecked : function(event) {
      if (event.target.checked) {
        console.log('Feuerwehr');
      
      }else{
        console.log("Feuerwehr deselected")
      
      }
    },
    polizeiChecked : function(event) {
      if (event.target.checked) {
        console.log('Polizei');
      
      }else{
        console.log("Polizei deseslected")
       
      }
    }, */
    // activateEdit(id) {
    //   const elements = document.getElementById(id);

    //   console.log("activateEdit", elements);

    //   for (let i = 0; i < elements.length; i++) {
    //     const element = elements[i];
    //     element.editing = true;
    //   }
    // },
    cancle(){
      this.$router.go(-1);
    },
    doAjax() {
                this.isLoading = true;
                // simulate AJAX
                setTimeout(() => {
                    this.isLoading = false
                }, 5000)
            },
            onCancel() {
              
                console.log('User cancelled the loader.')
            },

    danger() {
      const notif = Toast.open({
            duration: 5000,
            message: `Something's not good, also I'm on <b>bottom</b>`,
            position: 'is-bottom',
            type: 'is-danger',
            hasIcon: true
           })
         notif.$on('close', () => {
         Toast.open('Custom notification closed!')
        })
     },

async triggerEvent(value) {
      try{
      this.active = value;
      if(value){
      this.course.isPublic = true
      console.log("Public activated")
      this.active = true
      }else{
        this.course.isPublic = false
        console.log("Public deativated")
        this.active = false
      }
      }catch(err){
        this.error = true
      }
      
    },

    async triggerEventCC(value) {
      try{
      this.active = value;
      if(value){
      this.course.isInvite = true
      this.course.isInviteCourse = true
      console.log("CC activated")
      this.active = true
      }else{
        this.course.isInvite = false
        console.log("CC deativated")
        this.active = false
        this.course.isInviteCourse = false
      }
      }catch(err){
        this.error = true
      }
      
    },

    async triggerEventInvite(value) {
      try{
      this.active = value;
      if(value){
      this.course.isInviteCourse = true
      console.log("Invite activated")
      this.active = true
      }else{
        this.course.isInviteCourse = false
        console.log("Invite deativated")
        this.active = false
      }
      }catch(err){
        this.error = true
      }
      
    },

    async triggerEventProtect(value) {
      try{
      this.active = value;
      if(value){
      this.course.isProtected = true
      console.log("Protect activated")
      this.active = true
      }else{
        this.course.isProtected = false
        console.log("Protect deativated")
        this.active = false
      }
      }catch(err){
        this.error = true
      }
      
    },
    async triggerEventDraft(value) {
      try{
      this.active = value;
      if(value){
      this.course.isDraft = true
      console.log("Draft activated")
      this.active = true
      }else{
        this.course.isDraft = false
        console.log("Draft deativated")
        this.active = false
      }
      }catch(err){
        this.error = true
      }
      
    },

    noLicence(){
      this.course.noLicence = true
    },

    showMyModules() {
           console.log(this.$refs.modules);
        },
    
    activateSave() {
      this.edited = true;
            Toast.open({
            message: `Änderung erfolgreich`,
            position: 'is-top',
            type: 'is-success is-light'
         })
    },
    async checkChanges(e){
      e.preventDefault()
      try{
        this.countlicence()
      }catch(e){
        console.log(e)
      }
    },
    async saveChanges(e) {
      e.preventDefault()
      try{
        //this.doAjax()
      //console.log("updated course", this.course);
      
      // if(confirm("Do you really want to delete?")){
       const categoryName = document.getElementById("categories").value;
       const skillName = document.getElementById("skills").value;
      const courseName = this.course.name;

      //console.log("category", categoryName)
      //console.log("skill", skillName)

       if (categoryName === "Bitte auswählen:" && skillName === "Bitte auswählen:" || categoryName === "Bitte auswählen:" || skillName === "Bitte auswählen:" || this.course.sections == 0){
         // console.log("You need to set the mandatory values! Category and Skill!")
         Toast.open({
                     duration: 6000,
                     message: `Bitte die Kategorie und die Fähigkeit überprüfen! Zudem muss mindestens <b>ein</b> Kapitel erstellt sein! Der Kurs wurde <b>nicht</b> gespeichert!`,
                     position: 'is-top',
                     type: 'is-danger',
                     hasIcon: true
                 })  
                
       }else{
         console.log("All mandatory field are set!")
        
        Toast.open({
            message: `Der Kurs <b>`+ courseName + `</b> wurde erfolgreich gespeichert!`,
            duration: 8000,
            progressBar: true,
            position: 'is-top',
            type: 'is-success',
            pauseOnHover: true
         })
         this.course.courseCode = this.GUID.toUpperCase()
         this.$store.dispatch("create", this.course);
         this.$router.push({path: "/newcoursechoice"});
        // location.reload(this.$router.currentRoute);
       }
    // }
      // this.$store.dispatch("create", this.course);
      // this.$router.go(-2);
      }catch(error){
        this.error = true
      }
      
    },
    createSection() {
      this.edited = true;
      console.log("creating new section...");
      console.log("sections", this.course.sections)
      console.log("sectionsId", this.course.sections.length)
      this.course.sections.push({
        name: "Titel für Kapitel eingeben",
        description: "Beschreibung eingeben",
        index: this.course.sections ? this.course.sections.length : 0,
        modules: [],
      });
      Toast.open({
            message: `Neues Kapitel für den Kurs erstellt!`,
            position: 'is-bottom',
            type: 'is-success is-light'
         })
         this.bottom = document.body.scrollHeight
          window.scrollTo(0, this.bottom);
    },
    deleteSection(sectionIndex){
      this.edited = true;
      console.log("Delete section...");
      console.log("sections", this.course.sections)
      console.log("current section", this.course.sections[sectionIndex])
      console.log("current section id", this.course.sections[sectionIndex].index)
      try{
          Toast.open({
          message: `Kapitel <b>` + this.course.sections[sectionIndex].name + `</b> wurde entfernt!`,
          position: 'is-bottom',
          type: 'is-warning is-dark'
          })
          this.course.sections.splice(sectionIndex, 1)
          console.log("sections", this.course.sections)
          this.triggerEventCC(false)
                 // this.noLicence()
      }catch(e){
        console.log(e)
      }
    },
    countlicence(){
      this.edited = true;
      let response = this.course.sections
      console.log("res", response)
      
      var keyCountCourses = Object.keys(response).length
      console.log("keyCountCourses", keyCountCourses)
      var ObjectX = Object.keys(response)
      console.log("ObjectX", ObjectX)
      
      this.next = JSON.stringify(response)
      this.nextObject = response
      
      ObjectX.forEach((item, keyCountCourses) => {
          var ObjectModules = response[keyCountCourses].modules
          //var keyCountCourseModules = response[keyCountCourses].modules.length
          
          ObjectModules.forEach((item, index) => {
            //console.log(keyCountCourseModules)
                 //console.log("userObj1 collection count", item)
                 ObjectX.push({"id":keyCountCourses, "licence":this.nextObject[Object.keys(this.nextObject)[keyCountCourses]].modules[index].licence});
              })
              });
              //console.log("slice ObjectX", ObjectX.slice(keyCountCourses))
              this.JsonObjectA = ObjectX.slice(keyCountCourses)
              //console.log("JsonObjectA",this.JsonObjectA)
              
              const data = JSON.stringify(this.JsonObjectA)

 /*              const result = Object.keys(Object.assign({}, ...data))
              console.log(result)
              console.log(result.map(item => Object.keys(item)[0]));
              //const resultStr = JSON.stringify(result)
 */
              this.userObj1 = JSON.parse(data, (key, value) => {
                //console.log("value manifest object", key)
                if (value === false){
                  //console.log("licence position ist false", value)
                 
                    Toast.open({
                      message: `Der Kurs enthält ein Modul ohne CC-Lizenz und wird somit automatisch zu einem Invite Kurs!`,
                      duration: 4000,
                      position: 'is-top',
                      role: 'alert',
                      type: 'is-danger is-light',
                  })
                  this.triggerEventCC(true)
                  this.noLicence()

                  //console.log("Tag Detail Collection", this.tag)
                }
                
  /*               switch(key){
                  case this.currentRepo:

                    //console.log("-----> manifest Array", Object.values(this.manifestArray))
                    //console.log(Object.values(this.manifestArray)[1])
                    // Object.keys(obj)[0]
                    break;
                    default:
                      
                    } */
                    return value
                  })
              
    },
    /* Create Module
     createModule(sectionIndex) {
       this.edited = true;
       console.log("creating new module...");

       this.course.sections[sectionIndex].modules.push({
         name: "New Module",
         description: "Description",
         index: this.course.sections[sectionIndex].modules.length,
       });
     },
    */

    modulesNotInSection(sectionIndex) {
      let modulesInSection = this.course.sections[sectionIndex].modules;
      let modulesNotInSection = [];

      console.log("modulesInCourse", JSON.stringify(modulesInSection))
      console.log("module length", this.modules.length)

      let inSection = false;
      for (let i = 0; i < this.modules.length; i++) {
        const mod = this.modules[i];
        inSection = false;

       
        if (!inSection || !mod.name) modulesNotInSection.push(mod);
      }

      return modulesNotInSection;
    },

/*     modulesNotInCourse(sectionIndex) {
      let modulesInCourse = this.course.sections[sectionIndex].modules;
      let modulesNotInCourse = [];
      
      console.log("modulesInCourse", JSON.stringify(modulesInCourse))

      let inCourse = false;
      for (let i = 0; i < this.modules.length; i++) {
        const mod = this.modules[i];
        inCourse = false;

        for (let j = 0; j < modulesInCourse.length; j++) {
          const modInCourse = modulesInCourse[j];
          if (modInCourse.name === mod.name) inCourse = true;
        }
        if (!inCourse || !mod.name) modulesNotInCourse.push(mod);
      }

      return modulesNotInCourse;
    }, */

    addModule(sectionIndex) {
      this.edited = true;
      try{

        const modName = this.selectedOptions.name;
        const modSectionName = this.course.sections[sectionIndex].name;
        const mod = this.selectedOptions

        // console.log("mod before licence", mod)
        // console.log("mod licence", mod.licence)
        //  console.log("modSectionName", modSectionName)
        // console.log("modSection Id", JSON.stringify(modSectionId))
        // console.log("sectionIndex", sectionIndex)
  
        if (modSectionName){
          // console.log("modSectionName", modSectionName)
          this.course.sections[sectionIndex].modules.push(mod);
          //console.log("mod push", this.course.sections[sectionIndex].modules.push(mod))
          // console.log("sectionIndex", sectionIndex)
          // console.log("modName", modName)
          // console.log("modSectionName", modSectionName)
          
          Toast.open({
              message: `Das Modul <b>` + modName + `</b> wurde dem Kapitel <b>` + modSectionName + `</b> hinzugefügt`,
              position: 'is-top',
              duration: 8000,
              role: 'success',
              type: 'is-success is-light'
           })
           this.selectedOptions = []
        }else{
              Toast.open({
              message: `Es wurde kein Modul ausgewählt!`,
              position: 'is-top',
              duration: 8000,
              role: 'alert',
              type: 'is-danger is-light'
           })
        }
        //this.course.sections[sectionIndex].modules.push(mod);
      }catch(e){
        console.log(e)
      }
      
    },
  //   addModule(sectionIndex) {
  //     this.edited = true;
  //     try{
  //       //console.log("creating new module...");
  //       //console.log("modules in section", this.course.sections[sectionIndex].modules.length);
  //       //console.log("moduleId", this.modules.id);
  //       // console.log(this.$refs.modules);
  //       const modName = document.getElementById("modules").value;
  //       const modSectionName = this.course.sections[sectionIndex].name;
  //       // const modSectionId = this.course.sections[sectionIndex];
  
  //       const mod = this.modules.find((mod) => {
  //         //console.log("mod find", mod)
  //         //console.log("modId find", mod.id)
  //         //console.log("modIdentifier find", mod.identifier)
  //         //console.log("modName find", mod.name)
  //         //console.log("modName sections find", mod.sections.name)
  
  //         return mod.name == modName;
  //       });
  
  //       console.log("mod licence", mod.licence)
  
  // /*       console.log("modSectionName", modSectionName)
  //       console.log("modSection Id", JSON.stringify(modSectionId))
  //       console.log("sectionIndex", sectionIndex) */
  
  //       if (modSectionName){
  //         console.log("modSectionName", modSectionName)
  //         this.course.sections[sectionIndex].modules.push(mod);
  //         //console.log("mod push", this.course.sections[sectionIndex].modules.push(mod))
  //         console.log("sectionIndex", sectionIndex)
  //         console.log("modName", modName)
  //         console.log("modSectionName", modSectionName)
          
  //         Toast.open({
  //             message: `Das Modul <b>` + modName + `</b> wurde dem Kapitel <b>` + modSectionName + `</b> hinzugefügt`,
  //             position: 'is-bottom',
  //             duration: 8000,
  //             role: 'success',
  //             type: 'is-success is-light'
  //          })
  
  //       }else{
  //             Toast.open({
  //             message: `Es wurde kein Modul ausgewählt!`,
  //             position: 'is-bottom',
  //             duration: 8000,
  //             role: 'alert',
  //             type: 'is-danger is-light'
  //          })
  //       }
  //     }catch(e){
  //       console.log(e)
  //     }
  //     //this.course.sections[sectionIndex].modules.push(mod);
      
  //   },

    // orderCourseCategories() {
    //   if (this.course.course_category) {
    //     const category = this.courseCategories.find((category) => {
    //       return category.name === this.course.course_category.name;
    //     });

    //     for (let i = 0; i < this.courseCategories.length; i++) {
    //       const category_i = this.courseCategories[i];
    //       if (category_i.name === category.name) {
    //         let temp = this.courseCategories[0];
    //         this.courseCategories[0] = category_i;

    //         for (let j = 1; j <= i; j++) {
    //           let temp2 = this.courseCategories[j];
    //           this.courseCategories[j] = temp;
    //           temp = temp2;
    //         }
    //       }
    //     }
    //     console.log("courseCat ordered", this.courseCategories);
    //   }
    // },
    // orderSkills() {
    //   if (this.course && this.skills) {
    //     const skill = this.skills.find((skill) => {
    //       return skill.name === this.course.skill.name;
    //     });
    //     console.log("skill", skill);

    //     for (let i = 0; i < this.skills.length; i++) {
    //       const skill_i = this.skills[i];
    //       if (skill_i.name === skill.name) {
    //         let temp = this.skills[0];
    //         this.skills[0] = skill_i;

    //         for (let j = 1; j <= i; j++) {
    //           let temp2 = this.skills[j];
    //           this.skills[j] = temp;
    //           temp = temp2;
    //         }
    //       }
    //     }
    //     console.log("skills ordered", this.skills);
    //   }
    // },
/*     checkMandatoryValues(){
      const categoryName = document.getElementById("categories").value;
      const skillName = document.getElementById("skills").value;

      if (categoryName.value == 0 || skillName.value == 0){
        console.log("You need to set the mandatory values! Category and Skill!")
      }else{
        console.log("All mandatory field are set!")
      }
    }, */

    changeCategory() {
      this.edited = true;

      // console.log("changing category...");

      const categoryName = document.getElementById("categories").value;
      const category = this.courseCategories.find((category) => {
        return category.name === categoryName;
      });

      this.course.course_category = category;
      Toast.open({
            message: `Die Kategorie <b>` + categoryName + `</b> wurde ausgewählt`,
            position: 'is-top',
            duration: 6000,
            role: 'success',
            type: 'is-success is-light'
         })
      // console.log("nnew Category", this.course);
    },
    changeSkill() {
      this.edited = true;
      // console.log("changing skill...");

      const skillName = document.getElementById("skills").value;
      const skill = this.skills.find((skill) => {
        return skill.name === skillName;
      });

      this.course.skill = skill;
           Toast.open({
            message: `Die Fähigkeit <b>` + skillName + `</b> wurde ausgewählt`,
            position: 'is-top',
            duration: 6000,
            role: 'success',
            type: 'is-success is-light'
         })
      // console.log("nnew skill", this.course.skill.name);
    },

    // addFile(sectionIndex, modIndex) {
    //   this.edited = true;
    //   console.log("adding file...");

    //   const id = sectionIndex + "." + modIndex;
    //   console.log("id", id);

    //   const fileSelector = document.getElementById(id);
    //   console.log("fileSelector", fileSelector);
    //   fileSelector.addEventListener("change", (event) => {
    //     const newFile = event.target.files[event.target.files.length - 1];
    //     console.log("newFile", newFile);

    //     this.course.sections[sectionIndex].modules[modIndex].media.push(
    //       newFile
    //     );
    //   });
    // },
/*     activeTab(element) {
      if (element === "Videos") {
        this.tab = "Videos";
      } else if (element === "Slides") {
        this.tab = "Slides";
      } else if (element === "Audio") {
        this.tab = "Audio";
      }
    }, */
  },
  computed: {
    ...mapState({
      courseCategories: "courseCategories",
      usersCourses: "usersCourses",
    }),
    didLoad: function () {
      // this is just a bool to load the data setting methods when page is called. ignore its value.
      console.log("loading page...");
      return true;
    },
    classObject() {
    return {
      //active: this.noLicence,
      //active: this.course.isInvite,
      'inviteCourseDetected': this.noLicence,
    }
  },
  shownUUID: function() {
     var newGuid = this.GUID;
     if(this.isUpper === true) {
          newGuid = newGuid.toUpperCase();
        }
     if(this.withHyphen === false) {
       newGuid = newGuid.replace(/[-]/g,"");
     }
     return newGuid;
   },
   filteredData() {
    console.log(this.modules)
      return this.modules.filter((item) => item.name.toLowerCase().indexOf(this.searchTerm) >= 0);
    },
  },
  apollo: {
    // course: {
    //   query: gql`
    //     query ($id: ID!) {
    //       course(id: $id) {
    //         id
    //         name
    //         description
    //         duration
    //         isPublic
    //         isInvite
    //         isInviteCourse
    //         isProtected
    //         isDraft
    //         noLicence
    //         courseCode
    //         course_category {
    //           id
    //           name
    //         }
    //         skill {
    //           id
    //           name
    //         }
    //         instructor {
    //           firstName
    //           lastName
    //         }
    //         sections {
    //           id
    //           name
    //           description
    //           modules {
    //             id
    //             name
    //             description
    //             CC
    //             media {
    //               id
    //               name
    //               mime
    //               url
    //             }
    //           }
    //         }
    //         instructor {
    //           id
    //         }
    //       }
    //     }
    //   `,
    //   variables() {
    //     return {
    //       id: this.$route.params.id,
    //     };
    //   },
    // },
    modules: {
      query: gql`
        query {
          modules (start: 50, limit: 100) {
            id
            identifier
            name
            description
            licence
            iFrame_URL
            CC
            module_category{
              id
              name
            }
            sections {
              id
              name
            }
            media {
              id
              name
              mime
              url
            }
          }
        }
      `,
    },
    sectionsId: {
      query: gql`
              query {
					sections{
            id
            name
          }
        }
        `,
    },
    courseCategories: {
      query: gql`
        query {
          courseCategories {
            id
            name
          }
        }
      `,
    },
    skills: {
      query: gql`
        query {
          skills {
            id
            name
          }
        }
      `,
    },
  },
  watch: {
    // courseCategories: function () {
    //   this.orderCourseCategories();
    // },
    // skills: function () {
    //   this.orderSkills();
    // },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import url("https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css");
@import url("https://unpkg.com/buefy/dist/buefy.min.css");

  /* enter transitions */
  .toast-enter-active {
    animation: wobble 0.5s ease;
  }
  /* leave transitions */
  .toast-leave-to {
    opacity: 0;
    transform: translateY(-60px);
  }
  .toast-leave-active {
    transition: all 0.3s ease;
  }

body {
  font-family: "Lato", sans-serif;
}
.toggle__protect_button input[type="checkbox"] {
    opacity: 0;
    position: absolute;
    width: 1px;
    height: 1px;
}
.checkbox:checked {
  border: none;
}
.checkbox:checked + .check-icon {
  display: flex;
}
.color-blue {
  color: #0047ab;
}
.image {
  height: 200px;
}
.video {
  margin-top: 5rem;
  margin-bottom: 5rem;
}
.video-width {
  width: 100%;
}
.iframe-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
}

.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.panel {
    background-color: #ffffff;
    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.3);
    position:fixed;
    right:0px;
    bottom:10px;
    width:50em;
    z-index:100;
}
.lockedCourse {
    background-color: rgba(0, 0, 0, 0.05);
    display:inline-block;
    border-radius:6px;
    background: #BFCBD9;
    box-shadow: inset 0 0 1px #BFCBD9;
    position:relative;
    margin-left: 20px;
    width: 100%;
    transition: all .25s;
}
.publicCourse {
    display:inline-block;
    border-radius:6px;
    // background: #adedcb;
    box-shadow: inset 0 0 1px #dcd7d7;
    position:relative;
    width: 100%;
    transition: all .25s;
}
.inviteCourse {
    display:inline-block;
    border-radius:6px;
    // background: #3838fab6;
    box-shadow: inset 0 0 1px #dcd7d7;
    position:relative;
    width: 100%;
    transition: all .25s;
}
.inviteCourseDetected {
  background-color: rgba(0, 0, 0, 0);
  pointer-events: none !important;
}
.protectedCourse {
    display:inline-block;
    border-radius:6px;
    // background: #f42d97a8;
    box-shadow: inset 0 0 1px #dcd7d7;
    position:relative;
    width: 100%;
    transition: all .25s;
}
.iconPanel{
  margin-left: 30px;
}         
@media (max-width: 700px) {
         .long {
             max-width: 100%;
             flex-basis: 100%;
         }
         .image {
             width: 100%;
             height: 100%;
         }
}

@media screen and (max-width: 1023px) {

}
@media screen and (min-width: 1024px) {

}

/* a[href$=".pdf"] {
  background: url(/assets/images/PDF_file_icon.png) no-repeat left center;
  padding-left: 28px;
  border-bottom: none !important;
} */
</style>
